import { jsxs, jsx } from 'react/jsx-runtime';

const PayNow = () => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "64",
      height: "64",
      viewBox: "0 0 64 64",
      fill: "none",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M19.2727 32C19.2727 24.9709 24.9709 19.2727 32 19.2727C32.8514 19.2727 33.6798 19.3558 34.4787 19.5133C36.4492 19.9016 38.3613 18.619 38.7496 16.6486C39.1379 14.6782 37.8553 12.7661 35.8849 12.3778C34.6253 12.1295 33.326 12 32 12C20.9543 12 12 20.9543 12 32C12 43.0457 20.9543 52 32 52C43.0457 52 52 43.0457 52 32C52 30.4406 51.8209 28.9192 51.4809 27.457L44.5584 34.0785C43.5662 40.1189 38.3213 44.7273 32 44.7273C24.9709 44.7273 19.2727 39.0291 19.2727 32Z",
            fill: "#38D200"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M49.5051 19.225C50.9252 20.645 50.9252 22.9475 49.5051 24.3676L34.5234 39.3492L26.095 30.9209C24.675 29.5008 24.675 27.1984 26.095 25.7783C27.5151 24.3582 29.8176 24.3582 31.2376 25.7783L34.5234 29.064L44.3625 19.225C45.7826 17.8049 48.085 17.8049 49.5051 19.225Z",
            fill: "#0F7AED"
          }
        )
      ]
    }
  );
};

export { PayNow };
